var _desc, _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLimitAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Generic profile bust") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A generic grayscale bust avatar.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg",
    cx: "42%",
    cy: "22%",
    r: "74%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f2e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#b8b1a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a4644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stone",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e1d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#aca49c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d5752"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 37c8-14 31-22 51-10 18 11 25 30 19 51-4 15-18 29-35 34-21 6-43-3-52-20-9-17-2-39 17-55Z",
    fill: "url(#stone)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63 41c12-16 39-17 51-1 7 10 7 22 2 34-4-12-12-19-25-22-11-3-21-7-28-11Z",
    fill: "#d7d0c7",
    opacity: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68c7-8 18-8 27-4 9 4 18 10 29 8-2 14-10 25-24 30-15 5-31 1-39-10-6-8-4-17 7-24Z",
    fill: "#8d8580"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 80c8 2 18 1 29-3-2 9-6 17-13 21-9 5-21 2-26-5-4-6-1-11 10-13Z",
    fill: "#c6bdb4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57 100c11 14 31 19 50 11 10 13 17 25 21 42H34c3-18 11-36 23-53Z",
    fill: "#8f8780"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58 108c14 12 32 14 51 5 6 8 11 18 15 30H41c4-13 9-25 17-35Z",
    fill: "#c8bfb6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44 122c20 13 49 15 83 3 6 8 10 18 12 28H23c4-12 11-23 21-31Z",
    fill: "#5b5652"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 76,
    fill: "none",
    stroke: "rgba(255,255,255,.24)",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitAvatar);
export default __webpack_public_path__ + "static/media/limit-avatar.4268e247b503b83e881b18c10d709e39.svg";
export { ForwardRef as ReactComponent };